import util from '@bmp-vue/core/api/util'

const controller = 'Agenda'

export default Object.assign({}, util.GetCrud(controller, ['none']), {
  getSituacaoParcela (th, item) {
    const { Status, DtVencimento } = item;
    let statusParcela = {}
    switch (Status) {
      case th.$aux.SituacaoParcelaEnum.AVencer:
      case th.$aux.SituacaoParcelaEnum.Vencido:
        if (th.$api.UI.Date.DaysBetween(new Date(), DtVencimento) >= 0) {
          statusParcela = { text: 'A vencer', color: '#E4E7EC', textColor: '#000' }
        } else {
          statusParcela = { text: 'Vencida', color: 'red', textColor: '#FFF' }
        }
        break;
      case th.$aux.SituacaoParcelaEnum.Pago:
        statusParcela = { text: 'Paga', color: 'green', textColor: '#FFF' }
        break;
      case th.$aux.SituacaoParcelaEnum.Cancelado:
        statusParcela = { text: 'Cancelada', color: '#E4E7EC', textColor: '#000' }
        break
    };
    return statusParcela;
  },
  getSituacaoAgenda (th, item) {
    let statusAgenda = {}
    switch (item) {
      case th.$aux.SituacaoAgendaEnum.Aberta:
        statusAgenda = { text: 'Aberta', color: 'green', icon: 'mdi-circle' }
        break;
      case th.$aux.SituacaoAgendaEnum.Liquidada:
        statusAgenda = { text: 'Liquidada', color: 'blue', icon: 'mdi-check-circle' }
        break;
      case th.$aux.SituacaoAgendaEnum.Cancelada:
        statusAgenda = { text: 'Cancelada', color: 'red', icon: 'mdi-close-circle' }
        break
    };
    return statusAgenda;
  }
})
